<template>
  <v-col cols="12" class="pt-0">
    <v-alert
      class="text-left"
      :class="uiComponentProperties.rounded ? 'rounded-b-pill rounded-t-pill' : ''"
      :text="uiComponentProperties.text"
      :value="true"
      v-if="error"
      type="error"
    >
      {{ $t('login.o365_login_failed') }}
    </v-alert>

    <div class="o365-or text-center my-4">{{ $t('login.or') }}</div>

    <v-btn large block depressed color="white" class="o365-btn text-none rounded-lg" :loading="loading" @click="login">
      <svg class="o365-logo mr-3" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      {{ $t('login.sign_in_with_microsoft') }}
    </v-btn>
  </v-col>
</template>

<script>
import { loginWithMicrosoft } from '@/config/msal';

export default {
  name: 'O365Login',
  props: ['uiComponentProperties'],
  data() {
    return {
      loading: false,
      error: this.$route.query.o365_error === '1',
    };
  },
  watch: {
    '$route.query.o365_error'(value) {
      this.error = value === '1';
    },
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = false;
      try {
        // Sivu siirtyy Microsoftille, joten loading jää päälle
        await loginWithMicrosoft();
      } catch (e) {
        console.error('Microsoft login failed', e);
        this.error = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.o365-or {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.o365-logo {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

// Vaalea painike tummalla taustalla; pitkä teksti rivittyy kapealla näytöllä
.o365-btn.v-btn {
  color: #0d182f;
  font-size: 16px;
  letter-spacing: normal;
  height: auto;
  min-height: 48px;
  padding-top: 8px;
  padding-bottom: 8px;

  ::v-deep .v-btn__content {
    white-space: normal;
    flex: 1 1 auto;
    max-width: 100%;
  }
}
</style>
